import { twMerge } from '@shared/themes';
import { useTranslations } from 'next-intl';

type TitleProps = {
  variant: 'default' | 'sticky';
  namespace: string;
  className?: string;
};

/** Renders the Jackpot component title/branding */
function Title({ variant, namespace, className }: TitleProps) {
  const t = useTranslations(namespace);

  const classes = {
    wrapper: twMerge('flex flex-col gap-1 text-center justify-center', className),
    jackpotText: variant === 'default' ? 'heading-2 lg:heading-1' : 'heading-2 lg:heading-4',
    typeText: variant === 'default' ? 'heading-4 lg:heading-3' : 'heading-4 lg:paragraph-s-strong',
  };

  return (
    <div className={classes.wrapper}>
      <h2 className={classes.jackpotText}>{t('jackpot')}</h2>
      <p className={classes.typeText}>{t('type')}</p>
    </div>
  );
}

export { Title };
